import _ from 'lodash'

function convertToCSV (headers, items) {
  var result = [
    _.chain(headers).map(item => '"' + item.name + '"').join(',').value()
  ]
  _.each(items, item => {
    var row = []
    _.each(headers, head => {
      row.push('"' + item[head.field] + '"')
    })
    result.push(_.join(row, ','))
  })
  return _.join(result, '\n')
}

function exportCSVFile (headers, items, fileTitle) {
  var csv = convertToCSV(headers, items)
  var exportedFilenmae = fileTitle + '.csv' || 'export.csv'
  var blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
  if (navigator.msSaveBlob) { // IE 10+
    navigator.msSaveBlob(blob, exportedFilenmae)
  } else {
    var link = document.createElement('a')
    if (link.download !== undefined) { // feature detection
      // Browsers that support HTML5 download attribute
      var url = URL.createObjectURL(blob)
      link.setAttribute('href', url)
      link.setAttribute('download', exportedFilenmae)
      link.style.visibility = 'hidden'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }
}
export default {
  download: exportCSVFile
}
